var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.6,
    height: 21.6,
    viewBox: "0 0 21.6 21.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "target",
    transform: "translate(-1.2 -1.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_388",
    "data-name": "Ellipse 388",
    d: "M10-.8A10.8,10.8,0,0,1,20.8,10,10.8,10.8,0,0,1,2.363,17.637a10.8,10.8,0,0,1,0-15.273A10.729,10.729,0,0,1,10-.8Zm0,20A9.2,9.2,0,1,0,.8,10,9.21,9.21,0,0,0,10,19.2Z",
    transform: "translate(2 2)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_389",
    "data-name": "Ellipse 389",
    d: "M6-.8A6.8,6.8,0,1,1-.8,6,6.808,6.808,0,0,1,6-.8Zm0,12A5.2,5.2,0,1,0,.8,6,5.206,5.206,0,0,0,6,11.2Z",
    transform: "translate(6 6)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_390",
    "data-name": "Ellipse 390",
    d: "M2-.8A2.8,2.8,0,1,1-.8,2,2.8,2.8,0,0,1,2-.8Zm0,4A1.2,1.2,0,1,0,.8,2,1.2,1.2,0,0,0,2,3.2Z",
    transform: "translate(10 10)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.3060eae93da7cf21dea497426df13394.svg";
export { ForwardRef as ReactComponent };